module.exports = __webpack_public_path__ + "static/media/logo.dc592ff0.png";